// Styles et conventions a11y partagés par les 5 étapes d'onboarding, alignés
// sur ceux déjà établis dans FormCard.js (htmlFor/id, sr-only, gras des
// libellés de champ).
export const inCls = "text-sm border border-marine/20 rounded-sm p-2 bg-white focus:outline-none focus:border-marine/50 w-full";

export const Field = ({ id, label, required, children }) => (
  <div>
    <label htmlFor={id} className="block text-sm font-semibold text-marine mb-1">
      {label} {required && <span className="text-rouge" aria-hidden="true">*</span>}
      {required && <span className="sr-only"> (obligatoire)</span>}
    </label>
    {children}
  </div>
);
